import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/blogs/${slug}`).then((r) => setB(r.data)).catch(() => nav("/blog")); }, [slug, nav]);
  if (!b) return <div className="min-h-screen grid place-items-center text-[#0B5D3B]">Loading…</div>;

  return (
    <div className="font-body">
      <div className="h-[42vh] relative">
        <img src={b.image} alt={b.title} className="w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"/>
        <div className="absolute bottom-0 inset-x-0 max-w-3xl mx-auto px-5 pb-8 text-white">
          <span className="text-xs uppercase tracking-wide text-[#D4AF37] font-semibold">{b.category}</span>
          <h1 className="font-heading text-3xl lg:text-4xl font-bold mt-2">{b.title}</h1>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-5 py-14">
        <Link to="/blog" className="flex items-center gap-1.5 text-sm font-semibold text-[#0B5D3B] mb-8"><ArrowLeft size={16}/> Back to Blog</Link>
        <p className="text-lg text-gray-600 leading-relaxed whitespace-pre-line">{b.content}</p>
      </article>
    </div>
  );
}
